export const MIN_SIZE = 12;
export const MAX_SIZE = 20;
export const SIZE_STEP = 2;
